import { getEnvVar } from '../../Config/AppConfig';

export interface WalkieTalkieState {
  activeChannelSentinelId: number | null; // ID del letto con canale attivo (-1 o null = nessuno)
  isTalking: boolean; // Pulsante TALK premuto?
  isListening: boolean; // In modalità ascolto?
  timerHandle: number | null; // Riferimento al timer timeout (ReturnType<typeof setTimeout>)
  timerDuration: number; // Durata timer in millisecondi
  lastActivity: number; // Timestamp ultima attività (pressione TALK)
  activatedBy: 'alarm' | 'manual' | null; // Come è stato attivato il canale
}

// Legge durata timer da .env (in secondi) e converte in millisecondi
const getTimerDuration = (): number => {
  const durationSeconds = parseInt(
    getEnvVar('REACT_APP_WALKIE_TIMER_DURATION', '30')
  );
  return durationSeconds * 1000; // Converte in millisecondi
};

export const initialWalkieTalkieState: WalkieTalkieState = {
  activeChannelSentinelId: null,
  isTalking: false,
  isListening: false,
  timerHandle: null,
  timerDuration: getTimerDuration(),
  lastActivity: 0,
  activatedBy: null,
};
